import React, { useRef, useEffect } from 'react';
import Plotly from 'plotly.js';
export const PlotlyPlot = ({ data, layout }) => {
    const plotRef = useRef(null);
    useEffect(() => {
        if (plotRef.current !== null) {
            // Create the plot
            Plotly.newPlot(plotRef.current, data, layout);
            // Optional: return a cleanup function to remove the plot
            return () => {
                if (plotRef.current !== null) {
                    Plotly.purge(plotRef.current);
                }
            };
        }
    }, [data, layout]); // Re-run this effect if data or layout changes
    return React.createElement("div", { ref: plotRef });
};
//# sourceMappingURL=PlotlyPlot.js.map